<div class="logout-bar-container" *ngIf="show">
    <img [src]="profileImg" *ngIf="profileImg"/>
    <mat-icon fontSet="phr-iconset" class="phr-iconset-avatar" *ngIf="!profileImg"></mat-icon>
    <span [innerHtml]="'shared.logoutBar.title' | translate:locale.language: { name: profileName }"></span>
    <a (click)="onClick()">{{'shared.logoutBar.link' | translate:locale.language}}</a>
</div>